export default __webpack_public_path__ + "static/media/NB-IOT-PULSE.48e7e5f8.png";